import { SPLIT_TEST_NAME } from './SPLIT_TESTS';
import { assignAnonymousSplitTest } from './useAnonymousSplitTests';

// note - this test is really more of a cohort marker, not randomly assigned.
const ALWAYS_INCLUDE_FRACTION = 1;
const ALWAYS_INCLUDE_RANDOM_VALUE = 0;

export const recordMailPrefillSplitTest = (): Promise<void> =>
  assignAnonymousSplitTest({
    test_name: SPLIT_TEST_NAME.MAIL_PREFILL_V1,
    branch_name: 'INCLUDE',
    created: new Date().toISOString(),
    fraction: ALWAYS_INCLUDE_FRACTION,
    random_value: ALWAYS_INCLUDE_RANDOM_VALUE,
  });
